import { createInput } from "@formkit/vue";
import MultiFileInput from "../components/MultiFileInput.vue";
import InputNumberGroup from "../components/InputNumberGroup.vue";

export const customInputs = {
  multiFile: createInput(MultiFileInput, {
    props: [
      "maxValue",
      "minValue",
      "acceptedTypes",
      "maxFileSize",
      "accept",
      "capture",
      "multiple",
    ],
  }),
  numberGroup: createInput(InputNumberGroup, {
    props: ["items"],
    type: "input",
    family: "group",
  }),
};
